<div class="tw-w-11/12 lg:tw-max-w-5xl tw-p-4 tw-mt-4 tw-mb-8">
  <label
    for="prompt"
    class="tw-text-dark-light-dynamic tw-mb-2 tw-font-medium tw-text-base tw-flex tw-items-center tw-gap-2">
    Enter a prompt to generate people filters:
  </label>
  <div class="tw-flex tw-items-center tw-gap-4 tw-flex-wrap md:tw-flex-nowrap tw-py-2">
    <textarea
      matInput
      [(ngModel)]="prompt"
      id="prompt"
      rows="1"
      class="tw-block tw-p-2.5 tw-w-full tw-text-sm tw-text-gray-900 dark:tw-text-white tw-bg-white dark:tw-bg-gray-900 tw-rounded-lg tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-700"
      placeholder="E.g., find all engineers who worked at Google..."></textarea>

    <div class="tw-flex tw-gap-2">
      <button
        mat-stroked-button
        color="primary"
        class="tw-shrink-0"
        [class.spinner]="prompting"
        [disabled]="prompting"
        (click)="chat()">
        Build
        <mat-icon class="tw-text-base tw-rotate-[-30deg] tw-pb-[7px]">send</mat-icon>
      </button>
    </div>
  </div>
</div>
